export const formatPrice = (number: number) => {
  const formattedNumber = number?.toFixed(0)
  // formattedNumber = formattedNumber.endsWith('.00') ? formattedNumber.slice(0, -3) : formattedNumber

  return formattedNumber
}
